@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    display: flex;
    justify-content: center;
    gap: 1.25rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        align-items: center;
        flex-direction: column;
    }
}

.image {
    display: block;
    height: 52px;
    width: auto;
}
